import { useTranslation } from "react-i18next";
import { useLocale } from "../../hooks/useLocale";
import { localName, money } from "../../lib/format";
import type { Product } from "../../lib/types";

interface Props {
  addons: Product[];
  selected: Record<string, number>;
  onToggle: (id: string, on: boolean) => void;
}

const ICON: Record<string, string> = { "PADD-CAKE": "🎂", "PADD-MASCOT": "🧑‍🚀", "PADD-PHOTO": "📸", "PADD-HELIUM": "🎈" };

export function AddonChecklist({ addons, selected, onToggle }: Props) {
  const { t } = useTranslation();
  const { locale } = useLocale();
  return (
    <fieldset className="space-y-2">
      <legend className="label">{t("booking.addonChecklist")}</legend>
      <div className="grid grid-cols-2 gap-2 text-xs font-bold text-gray-700">
        {addons.map((a) => (
          <label key={a.id} className="flex cursor-pointer items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 p-2">
            <input type="checkbox" className="rounded text-cosmic-purple focus:ring-0" checked={!!selected[a.id]} onChange={(e) => onToggle(a.id, e.target.checked)} />
            <span className="text-[11px]">{ICON[a.sku] ?? "✨"} {localName(a, locale)} <span className="num text-gray-400">(+{money(a.price)})</span></span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
